export function common() {

  var ua = navigator.userAgent;
  var viewport = document.querySelector("meta[name=viewport]");
  if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
    viewport.setAttribute("content", "width=device-width,initial-scale=1");
  } else {
    viewport.setAttribute("content", "width=1080");
  }

  // スマホtel link
  if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
    jQuery(function($) {
        $('.tel').each(function() {
            var str = $(this).html();
            if ($(this).children().is('img')) {
                $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
            } else {
                $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
            }
        });
    });
  }


  var wH = $(window).height(),
        navpos = $('header').offset().top,
        navH = $('.l-header').outerHeight(true);

  $(window).on('load scroll',function(){
    var scrl = $(this).scrollTop();
    if (window.matchMedia('screen and (min-width:761px)').matches) { 
      if(scrl > navpos){
        $('header').addClass('is-fixed');
        $('header').css('height',navH + 'px');
      }else{
        $('header').removeClass('is-fixed');
        $('header').css('height','');
      }
    }

    if(scrl > wH/2){
      $('.pagetop').fadeIn(200);
    }else{
      $('.pagetop').fadeOut(100);
    }
  });
  
  $('.js-toggle').on('click',function(){
    if($(this).hasClass('is-active')){
      $(this).removeClass('is-active');
      $('.l-header_navArea').fadeOut(200);
    }else{
      $(this).addClass('is-active');
      $('.l-header_navArea').fadeIn(300);
    }
  });

  if (window.matchMedia('screen and (max-width:760px)').matches){
    $('.js-navClose').click(function() {
      $('.js-toggle').removeClass('is-active');
      $('.l-header_navArea').fadeOut(200);
    });
  }
  
  //ヘッダーの高さに連動
  function headerHeightSwitch() {
    var headerHeight = $('.l-header').outerHeight(); //ウィンドウサイズ取得
    var pollHeight = $('.p-indexPoll').outerHeight(); //ウィンドウサイズ取得
    $('#poll').css({'height': pollHeight});
    $('.anchor').css({'padding-top': headerHeight});
    $('.anchor').css({'margin-top': -headerHeight});
  }
  headerHeightSwitch();
  $(window).on('resize', function () {
    headerHeightSwitch();
  });


  //ページトップ
  var pageTop = $('#pageTop');
  pageTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 650) {
      pageTop.fadeIn();
    } else {
      pageTop.fadeOut();
    }
  });
  pageTop.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 550);
    return false;
  });

  //スムーススクロール
  $('a[href^="#"]').click(function () {
    var speed = 550;
    var href = $(this).attr("href");
    var headerHight = $('.l-header').outerHeight();
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - headerHight;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  //タブ切り替え
  $('.js-tab').on('click', function() {
    var target = $(this).data('target');
    var $group = $(this).closest('.js-tabGroup');

    $group.find('.js-tab').removeClass('is-active');
    $(this).addClass('is-active');

    $group.find('.js-tabPanel').removeClass('is-active');
    $group.find('.js-tabPanel[data-target="' + target + '"]').addClass('is-active');
  });
}
